import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="livestream-events.access-zoom-capacitor.text"
    defaultMessage="Please use our website or desktop app to access the meeting."
  />
);
